import { render } from "./fullpage.vue?vue&type=template&id=a40b5616&scoped=true&lang=pug"
import script from "./fullpage.vue?vue&type=script&lang=js"
export * from "./fullpage.vue?vue&type=script&lang=js"

import "./fullpage.vue?vue&type=style&index=0&id=a40b5616&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40b5616"]])

export default __exports__